<template>
  <div>
    <loader :loading="loading"/>
    <form @submit.prevent="submit" class="form" v-if="schema" :ref="schema.title">
      <json-form :schema="schema" v-model="model" :errors="errors"/>
      <button type="submit" class="btn btn-primary btn-sm w-100">
        <Icon prefix="fas" name="save" class="mr-2"/>
        {{ $t('save') }}
      </button>
    </form>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { AxiosResponse } from 'axios';
import { EventBus } from '@/services/EventBus';
import { FormComponent } from '@/mixins/FormComponent';

@Component({})
export default class TaskCommunicationCreate extends mixins(FormComponent) {
  protected model: any = {};
  protected endpoint!: string;

  protected setEndpointAndLoad() {
    this.endpoint = `/task/${this.$route.params.taskId}/communication/create`;

    this.loadData();
  }

  protected created() {
    this.setEndpointAndLoad();

    this.$store.commit('bars/setRightBarTitle', 'loading');
  }

  protected async handleSubmitSuccessful(res: AxiosResponse<any>) {
    EventBus.$emit('form.submit.successful');
    this.loading = false;
    this.afterSubmit(true, res);
  }

  protected afterLoad(response: AxiosResponse) {
    const title: string = this.schema && this.schema.title ? this.schema.title : '';
    if (title) {
      this.$store.commit('bars/setRightBarTitle', this.$t(title + '.header'));
    }
    this.$store.commit('bars/setRightBarFormSubmit', this.submit);
  }
}
</script>

<style scoped lang="scss">
</style>
